import FinanceForecastInstance from "./instance"

const FinanceForecastApi = {
    fetchFinancialLevers: (payload) => {
        return FinanceForecastInstance.post(`/firstcall`, payload)
    },
    predict: (payload) => {
        return FinanceForecastInstance.post(`/predict`, payload)
    },
}

export default FinanceForecastApi;